
import DateUtil from 'Utils/dateUtil';

export default [
    {
        type: 'selection',
        width: 38,
        align: 'center'
    },

    {
        title: 'Name',
        key: 'Name',
        sortable: true,
        minWidth: 80,
    },

	{
        title: 'Claim Name',
        key: 'ClaimName',
		sortable: true,
        minWidth: 80,
    },

    
    {
        title: 'Approved By',
        key: 'ApprovedBy',
        minWidth: 80,
    },
    {
        title: 'Approved On',
        key: 'ApprovedOn',
        minWidth: 80,

    },
    {
        title: 'Amount',
        // key: 'amount',
        minWidth: 80,
         render: (h, params) => {
            return h('span',params.row.amount?parseFloat( params.row.amount).toFixed(2):'');
        },
    },
  
 
]
